// styles
import styled from 'styled-components';
// components
import Tooltip from 'components/Tooltip';
import { GirdedQuestionIcon } from 'refactored/ui/icons';
import { useTranslation } from 'react-i18next';

const TagWithArrow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px;
  height: 24px;
`;

const TagArrow = styled.div`
  border: solid var(--primary100)
  border-width: 0 8px 8px 0;
  display: inline-block;
  padding: 3px;
  -webkit-transform: rotate(135deg) translateX(-2px) translateY(-3px);
  -ms-transform: rotate(135deg) translateX(-2px) translateY(-3px);
  transform: rotate(135deg) translateX(-4px) translateY(-5px);
`;

const TagTextContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 4px;
  gap: 4px;
  width: 35px;
  height: 24px;
  background: var(--primary100);
  border-radius: 2px;
`;

const TagText = styled.div`
  width: 27px;
  height: 16px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  align-items: center;
  color: var(--grey700);
`;

const SoFormCandidateBlockDetailsPriceBreakdownItemConcept = ({
  concept,
  className,
  index,
  isHandlingIncluded,
}) => {
  const description = concept.strikethrough ? (
    <del>{concept.concept}</del>
  ) : (
    concept.concept
  );
  const { t } = useTranslation('Quote');

  const showHandlingIncluded = index === 0 && isHandlingIncluded;

  return (
    <div className={className}>
      <span>
        {description}{' '}
        {showHandlingIncluded && (
          <b>
            <br />
            {t('handling_included')}
          </b>
        )}
      </span>
      {concept.tagLabel && (
        <TagWithArrow>
          <TagArrow></TagArrow>
          <TagTextContainer>
            <TagText>{concept.tagLabel}</TagText>
          </TagTextContainer>
        </TagWithArrow>
      )}
      {concept.tooltipInnerComponent() && (
        <Tooltip
          className="tooltip"
          component={concept.tooltipInnerComponent()}
          skin="light"
          position="bottom"
          segmentTitle="form price_breakdown"
          segmentData={{ concept: concept.concept }}
        >
          <GirdedQuestionIcon />
        </Tooltip>
      )}
    </div>
  );
};

export default styled(SoFormCandidateBlockDetailsPriceBreakdownItemConcept)`
  width: 468px;
  height: 24px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: var(--grey700);
  gap: 8px;
  display: flex;
  align-items: center;
  ${GirdedQuestionIcon} {
    path {
      fill: var(--grey300);
    }
  }
`;
